import React, { useState, useEffect, useRef } from 'react';
import { TailSpin } from 'react-loader-spinner';
import ReactPlayer from 'react-player';
// react-player/youtube

const formatTime = (seconds) => {
  const hrs = Math.floor(seconds / 3600);
  const mins = Math.floor((seconds % 3600) / 60);
  const secs = Math.floor(seconds % 60);
  const padded = (val) => String(val).padStart(2, '0');
  return `${hrs > 0 ? padded(hrs) + ':' : ''}${padded(mins)}:${padded(secs)}`;
};

const AdWithCountdown = ({onAdFinish}) => {
  const [countdown, setCountdown] = useState(null);
  const [videoDuration, setVideoDuration] = useState(null);
  const [muted, setMuted] = useState(true);
  const [skipDelay] = useState(30); // seconds before skip allowed

  const [skipTimer, setSkipTimer] = useState(skipDelay);
  const [isBuffering, setIsBuffering] = useState(true);
  const playerRef = useRef();

  useEffect(() => {
    if (videoDuration !== null && countdown === null) {
      setCountdown(Math.floor(videoDuration));
    }
  }, [videoDuration]);

  useEffect(() => {
    if (countdown > 0 && !isBuffering) {
      const timer = setInterval(() => {
        setCountdown((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(timer);
    } else if (countdown === 0) {
      onAdFinish()
    }
  }, [countdown,isBuffering]);

  useEffect(() => {
    if (countdown === 0) {
      onAdFinish(); // Notify parent that the ad has finished
    }
  }, [countdown, onAdFinish]);

  // Decrease skip timer until 0
  useEffect(() => {
    if (skipTimer > 0 && !isBuffering) {
      const skipInterval = setInterval(() => {
        setSkipTimer((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(skipInterval);
    }
  }, [skipTimer, isBuffering]);


  const handleSkipAd = () => {
    if (skipTimer <= 0) {
      onAdFinish()
    }
  };

  const toggleMute = () => {
    setMuted((prev) => !prev);
  };

  return (
    <div style={{ height: '100vh', overflow: 'hidden' }}>
        <div style={{ position: 'relative', height: '100%' }}>
          {/* Countdown Display */}
          {countdown !== null && (
            <div
              style={{
                position: 'absolute',
                top: 10,
                right: 10,
                backgroundColor: 'rgba(0,0,0,0.6)',
                color: '#fff',
                padding: '5px 10px',
                borderRadius: '8px',
                zIndex: 1,
                fontFamily: 'monospace',
                fontSize: '16px',
                minWidth: '120px',
                textAlign: 'center',
              }}
            >
              Ad ends in: {formatTime(countdown)}
            </div>
          )}

          {/* Skip Button with countdown */}
          <button
            onClick={handleSkipAd}
            disabled={skipTimer > 0}
            style={{
              position: 'absolute',
              bottom: 20,
              right: 20,
              padding: '8px 16px',
              backgroundColor: '#f00',
              color: '#fff',
              border: 'none',
              borderRadius: '5px',
              cursor: skipTimer > 0 ? 'not-allowed' : 'pointer',
              zIndex: 1,
            }}
            title={skipTimer > 0 ? `You can skip ad in ${skipTimer}s` : 'Skip Ad'}
          >
            {skipTimer > 0 ? `Skip Ad (${skipTimer}s)` : 'Skip Ad'}
          </button>

          {/* Mute/Unmute Toggle */}
          <button
            onClick={toggleMute}
            style={{
              position: 'absolute',
              bottom: 20,
              left: 20,
              padding: '8px 16px',
              backgroundColor: '#007bff',
              color: '#fff',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
              zIndex: 1,
            }}
          >
            {muted ? '🔇 Unmute' : '🔊 Mute'}
          </button>

          {isBuffering && (
          <div
            style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              zIndex: 3,
              color: '#fff',
              fontSize: '24px',
              fontWeight: 'bold',
              backgroundColor: 'rgba(0,0,0,0.5)',
              padding: '10px 20px',
              borderRadius: '10px',
            }}
          >
            <TailSpin
              visible={true}
              height="80"
              width="80"
              color="#8000D5"
              ariaLabel="tail-spin-loading"
              radius="1"
              wrapperStyle={{}}
              wrapperClass=""
            />
          </div>
        )}

          {/* YouTube Player */}
          <ReactPlayer
            ref={playerRef}
            url="https://monarchinstitute.in/static-files/Monarchad.mp4"
            playing
            muted={muted}
            controls={false}
            width="100%"
            height="100%"
            onEnded={onAdFinish}
            onDuration={(duration) => setVideoDuration(duration)}
            onError={(e) => console.error('ReactPlayer error:', e)}
            onBuffer={() => setIsBuffering(true)}
            onBufferEnd={() => setIsBuffering(false)}
            config={{
              file: {
                forceVideo: true,
                attributes: {
                  controlsList: 'nodownload',
                  autoPlay: true,
                  muted: muted,
                  playsInline: true,
                },
              },
              // youtube: {
              //   playerVars: {
              //     modestbranding: 1,
              //     rel: 0,
              //     showinfo: 0,
              //     fs: 0,
              //     iv_load_policy: 3,
              //     disablekb: 1,
              //   },
              // },
            }}
            style={{ position: 'absolute', top: 0, left: 0 }}
          />
        </div>
    </div>
  );
};

export default AdWithCountdown;
